import React from 'react';
import { Select } from 'antd';
const { Option } = Select;
export const BaseSelectComponent = ({ options = [], value, onChange, placeholder, error, touched, onChangeAsObject = false, style, ...props }) => {
  // Normalize value to prevent 'label' mismatch warning when options are loading or labels mismatch
  let selectValue = value;
  if (value === '' || value === null) {
    selectValue = undefined;
  }
  let labelInValueProp = props.labelInValue;

  if (value && typeof value === 'object') {
    const matchingOption = options.find(option => option.value === value.value);
    if (matchingOption) {
      // Synchronize label with option label to prevent warning
      selectValue = {
        value: value.value,
        label: matchingOption.label
      };
      if (labelInValueProp === undefined) {
        labelInValueProp = true;
      }
    } else if (!value.label) {
      // If no option matches and label is falsy/empty, pass raw value to prevent warning
      selectValue = value.value;
    } else {
      // Keep object as is if it has a label, but ensure labelInValue is true so antd expects it
      if (labelInValueProp === undefined) {
        labelInValueProp = true;
      }
    }
  }

  const handleSelectChange = (val) => {
    const rawVal = val && typeof val === 'object' ? val.value : val;
    if (onChangeAsObject) {
      const selectedOption = options.find(option => option.value === rawVal);
      onChange(selectedOption || { value: rawVal, label: val && typeof val === 'object' ? val.label : '' });
      return;
    }
    onChange(rawVal);
  };

  return (
    <div style={style}>
      <Select
        showSearch
        style={{ width: '100%', ...(style?.height ? { height: style.height } : {}) }}
        allowClear
        value={selectValue !== undefined ? selectValue : undefined}
        labelInValue={labelInValueProp}
        onChange={handleSelectChange}
        placeholder={placeholder}
        optionFilterProp="children"
        filterOption={(input, option) =>
            option.children ? option.children.toString().toLowerCase().includes(input.toLowerCase()) : false
        }
        {...props} //let the component accept external properties (e.g. state)
      >
        {options.map(option => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
      {touched && error ? (
        <div className="text-danger" style={{ fontSize: '13px', marginTop: '4px' }}>
          {error}
        </div>
      ) : null}
    </div>
  );
};